var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_181_1",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 181 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.999,
    viewBox: "0 0 20 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13047",
    "data-name": "\\u30D1\\u30B9 13047",
    d: "M103.375,90.316h20v19.467h-20Z",
    transform: "translate(-103.375 -90.283)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_16731",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16731",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13071",
    "data-name": "\\u30D1\\u30B9 13071",
    d: "M106.913,90.283c0,.78-.025,1.566-.025,1.566h-2.347a.754.754,0,0,0-.782.728q0,.027,0,.053V95.1h17.988V92.63a.756.756,0,0,0-.73-.781h-2.4V90.283h-2.343v1.566h-7.045V90.283Zm-3.154,6.394v11.6a.758.758,0,0,0,.731.783h16.485a.758.758,0,0,0,.783-.731.473.473,0,0,0,0-.053v-11.6Zm14.474,9.252H114.32v-3.911h3.912Z",
    transform: "translate(-102.758 -89.783)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10039",
    "data-name": "\\u9577\\u65B9\\u5F62 10039",
    width: 19.999,
    height: 19.999,
    transform: "translate(0 0.5)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.32ffceee8e2f4d5a0eb7476afdcbabcb.svg";
export { ForwardRef as ReactComponent };